import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      id: 1,
      icon: 'Zap',
      iconColor: 'text-yellow-400',
      bgColor: 'bg-yellow-400/10',
      title: 'Lightning Fast Learning',
      description: 'Master Shakespeare 3x faster with our proven methodology and bite-sized lessons designed for quick comprehension.'
    },
    {
      id: 2,
      icon: 'Target',
      iconColor: 'text-blue-400',
      bgColor: 'bg-blue-400/10',
      title: 'Gamified Experience',
      description: 'Level up your skills and unlock achievements as you progress through plays, making learning addictively fun.'
    },
    {
      id: 3,
      icon: 'TrendingUp',
      iconColor: 'text-green-400',
      bgColor: 'bg-green-400/10',
      title: 'Smart Performance Tools',
      description: 'Practice shows reveal your strengths and areas for improvement with detailed analytics and personalized feedback.'
    },
    {
      id: 4,
      icon: 'Users',
      iconColor: 'text-purple-400',
      bgColor: 'bg-purple-400/10',
      title: 'Squad Learning',
      description: 'Join study groups, compete on leaderboards, and learn together with fellow Shakespeare enthusiasts worldwide.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 relative">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            Why Students Choose <span className="gradient-text">BardPlay</span>
          </h2>
          <p className="text-base sm:text-lg text-white/70 max-w-3xl mx-auto">
            We've revolutionized Shakespeare education with cutting-edge lessons and gamification to create the most engaging learning experience ever built.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits?.map((benefit) => (
            <div
              key={benefit?.id}
              className="modern-card group hover:scale-105 transition-transform duration-300"
            >
              <div className="mb-6">
                <Icon name={benefit?.icon} size={32} className={benefit?.iconColor} />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                {benefit?.title}
              </h3>
              <p className="text-white/70 leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;